import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Col,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
} from "reactstrap";
import { useDispatch } from "react-redux";
import {
  addUserByRole,
  getRolesAdmin,
  downloadAllEmployersReport,
} from "../../slices/admin/thunk";
import Loading from "../../Components/Loading";
import EmployerGroupsTable from "../../Components/Tables/EmployerGroupTable/EmployerGroupTable";
import Swal from "sweetalert2";
import AddRoleModal from "../../Components/modals/GeneralModals/AddRoleModal";
import { DASHBOARD_USER_ROLES } from "../../constants";
import SearchBar from "../../Components/SearchBar/SearchBar";
import ButtonAddRole from "../../Components/Buttons/ButtonAddRole";
import HeadersRole from "../../Components/Headers/HeadersRole";
import DropdownActionsTable from "../../Components/Dropdown/DropdownActionsTable.js";
import employerGroupIcon from "../../assets/images/iconsRoles/employerGroupIcon.svg";
const DashboardAdminEmployerGroups = () => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [loadingCreate, setLoadingCreate] = useState(false);

  const [modalAddEmployerGroups, setModalAddEmployerGroups] = useState(false);

  const [employers, setEmployers] = useState([]);
  const [totalEmployers, setTotalEmployers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const handleToggleModal = () => {
    setModalAddEmployerGroups(!modalAddEmployerGroups);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchRolesAdmin = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesAdmin({
          role: "employers",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployers(response.data);
      setTotalEmployers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setLoading(false);
      setSearchDone(true);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchRolesAdmin();
  }, [currentPage, debouncedSearchTerm, dispatch]);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  const handleCreateEmployerGroup = async (values) => {
    try {
      setLoadingCreate(true);
      const response = await dispatch(
        addUserByRole({ role: DASHBOARD_USER_ROLES.EMPLOYER, data: values })
      ).unwrap();
      if (!response.error) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Employer Group created successfully",
          timer: 2000,
          showConfirmButton: false,
        });
        setLoadingCreate(false);
        setModalAddEmployerGroups(false);
        fetchRolesAdmin();
      } else {
        Swal.fire({
          title: "Error!",
          text: response.error || "An error occurred while adding the employer",
          icon: "error",
          confirmButtonText: "OK",
        });
        setModalAddEmployerGroups(true);
        setLoadingCreate(false);
        console.log(response.error);
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.message || "An error occurred while adding the employer",
        icon: "error",
        confirmButtonText: "OK",
      });
      setModalAddEmployerGroups(true);
      setLoadingCreate(false);
      console.log(error);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      {modalAddEmployerGroups && (
        <AddRoleModal
          open={modalAddEmployerGroups}
          setOpen={setModalAddEmployerGroups}
          roleToAdd="Employer Group"
          onCreate={handleCreateEmployerGroup}
          loading={loadingCreate}
        />
      )}
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole
            role="Employer Groups"
            icon={employerGroupIcon}
            svg={true}
          />
          <Card className="mb-4 pb-3 ">
            <CardBody>
              <div className="col-12 d-flex justify-content-between mt-1 mb-4 align-items-center ">
                <div className="col-4 d-flex justify-content-end align-items-center">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name, email or company name "
                    shouldDisplaySearchBar={true}
                    setSearchTerm={setSearchTerm}
                  />
                  <DropdownActionsTable
                    downloadMethod={downloadAllEmployersReport}
                  />
                </div>

                <ButtonAddRole
                  open={handleToggleModal}
                  roleToAdd="Employer Group "
                />
              </div>

              <Col xl={12}>
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <EmployerGroupsTable
                        data={employers}
                        searchParam={debouncedSearchTerm}
                        paginationProps={{
                          itemsCount: employers.length,
                          totalPages: totalPages,
                          totalItems: totalEmployers,
                          currentPage: currentPage,
                          onChangePage: handleChangePage,
                        }}
                        searchDone={searchDone}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardAdminEmployerGroups;
